var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstName,
                          expression: "firstName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "firstName",
                        placeholder: "Enter First Name"
                      },
                      domProps: { value: _vm.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.firstNameError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.lastName,
                          expression: "lastName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "lastName", placeholder: "Enter Last Name" },
                      domProps: { value: _vm.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.lastName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.lastNameError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "email", placeholder: "Enter Email" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.emailError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dayforceId,
                          expression: "dayforceId"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "dayforceId",
                        placeholder: "Enter DayforceId"
                      },
                      domProps: { value: _vm.dayforceId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.dayforceId = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.dayforceIdError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            name: "roleId",
                            id: "roleId",
                            label: "name",
                            filterable: true,
                            options: _vm.roleOptions,
                            placeholder: "Select Role"
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChnageRole()
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.name) +
                                        "\n                                    "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "selected d-center" },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(option.name) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.roleId,
                            callback: function($$v) {
                              _vm.roleId = $$v
                            },
                            expression: "roleId"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n                                    Search Location...\n                                "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.roleError))
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-margin checkbox_container" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _vm._l(_vm.allPermissions, function(
                        allPermission,
                        index
                      ) {
                        return [
                          _c("input", {
                            key: allPermission.id,
                            attrs: { type: "checkbox", name: "permission[]" },
                            domProps: { value: allPermission.id }
                          }),
                          _vm._v(" " + _vm._s(allPermission.name)),
                          _c("br")
                        ]
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdateUser()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdateUser((_vm.flag = "Save and Continue"))
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("First Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Last Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Email : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("DayforceId: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Role :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Permissions :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17e05e01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e05e01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/AddUpdateUser.vue
// module id = null
// module chunks = 